import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCard from '../shared/SectionCard'
import FileUploadField from '../shared/FileUploadField'
import './style.css'

const EditGallery = ({ formHandler, providerInfo }) => {
    const { t } = useTranslation()

    return (
        <SectionCard 
            title={t("gallery")} 
            icon="mdi:image-multiple"
            className="edit-gallery"
        >
            <div className="edit-form-grid">
                <FileUploadField
                    formHandler={formHandler}
                    name="galleryImages"
                    label={t("upload-gallery-images")}
                    accept="image/*"
                    multiple
                    maxFiles={10}
                    helperText={t("gallery-upload-hint")}
                />
            </div>
        </SectionCard>
    )
}

export default EditGallery

